import { patientAction } from '../../actions/constant';

const { GET_ALL_PATIENT_FAILURE, GET_ALL_PATIENT_SUCCESS, GET_ALL_PATIENT_REQUEST } = patientAction;

const intitialstate: object = {
    response: null,
    isError: false,
    errorMessage: '',
    loading: false,
};

export const getAllPatientReducer = (state = intitialstate, action: any) => {
    switch (action.type) {
        case GET_ALL_PATIENT_SUCCESS: {
            return {
                ...state,
                isError: false,
                response: action.payload?.data,
                loading: false,
            };
        }

        case GET_ALL_PATIENT_FAILURE:
            return {
                ...state,
                isError: true,
                errorMessage: action.payload,
                response: null,
                loading: false,
            };

        case GET_ALL_PATIENT_REQUEST:
            return {
                ...state,
                loading: true,
            };

        default:
            return state;
    }
};
